export const addWatermarker = (element, text) => {
  const canvas = document.createElement('canvas')
  element.appendChild(canvas)
  canvas.width = 320
  canvas.height = 160
  canvas.style.display = 'none'
  const context: any = canvas.getContext('2d')
  context.rotate((-15 * Math.PI) / 180)
  context.font = '14px Helvetica Neue'
  context.fillStyle = 'rgba(70, 70, 70, 0.1)'
  context.textAlign = 'left'
  context.textBaseline = 'Middle'
  context.fillText(text, canvas.width / 4, canvas.height / 2)
  element.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`
}
